import api from './api';
export async function redirectLegacyAnnulment(to, from, next) {
    try {
        const {data: config} = await api.get('/api/requests/items/report-annulment/config');
        if (!config.enabled) return next();
        const legacyId = to.params.id || to.query.request || String(to.hash || '').replace(/^#/, '');
        if (/^\d+$/.test(String(legacyId))) {
            const {data} = await api.get(`/api/requests/items/report-annulment/legacy/${legacyId}`);
            return next({name: 'request-card', params: {id: data.request_id}, query: to.query, replace: true});
        }
        return next(to.path.endsWith('/create') ? {name: 'create-request', query: {requestTypeId: config.request_type_id}, replace: true}
            : {path: '/requests', query: {request_type_id: config.request_type_id, tab: 'all'}, replace: true});
    } catch (e) { next(); }
}
